export default __webpack_public_path__ + "static/reward@2x-1c992f49ff0467977764d9790ca83008.png";